// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"07fd475d","623":"0513602e","744":"cecd851c","923":"ce7bf03b"}[chunkId] + ".chunk.css";
};